export interface PutJobOnHoldBlockModelInterface {
    reasonId: number;
    reasonDisplayName: string;
}

export class PutJobOnHoldBlockModel implements PutJobOnHoldBlockModelInterface {
    reasonDisplayName: string = '';
    reasonId: number = undefined;

    constructor(data:{} = undefined) {
        if(data) {
            this.reasonDisplayName = data['reasonDisplayName'] ? data['reasonDisplayName'] : '';
            this.reasonId = data['reasonId'] ? parseInt(data['reasonId']) : undefined;
        }
    }
}
